export default "__VITE_ASSET__IUKnhamw__"